module.exports = __webpack_public_path__ + "img/20.23b6c5b4.png";